import dayjs from "dayjs";

export const hasTheSameDateString = (messageDate: string, previousMessageDate: string | undefined) => {
  if (!messageDate || !previousMessageDate) {
    return true;
  }

  return dayjs(messageDate).format("DD.MM.YYYY") === dayjs(previousMessageDate).format("DD.MM.YYYY");
};
